import styled from 'styled-components';

export default styled.div`
    display: flex;

    .topControlBlockButton {
        margin-right: 0.5rem;
    }
`;
